<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "@/components/widgets/preloader";
    import { mapGetters,mapActions,mapState } from "vuex"
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Product Average Consumption",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        Loader,
        ModelListSelect,
      },
      data() {
        return {
          filterSales:{
            month: 0,
            year: moment().year(),
          },
          currentdate: moment(new Date()).format("YYYY-MM-DD"),
          title: "Product Average Consumption",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "Product Average Consumption",
              active: true,
            },
          ],
          totalRows: 1,
    
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          modal_id: "",
          monthfields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "product",
              sortable: true,
              label: 'Product',
            },
            {
              key: "totalsales",
              sortable: true,
              label: 'All SALES',
            },
            {
              key: "permonth",
              sortable: true,
              label: 'PER MONTH',
            },
            {
              key: "perday",
              sortable: true,
              label: 'PER DAY',
            },
            
          ],
          Months: [
            { id: 0, text:"All Months"},
            { id: 1, text:"January"},
            { id: 2, text:"February"},
            { id: 3, text:"March"},
            { id: 4, text:"April"},
            { id: 5, text:"May"},
            { id: 6, text:"June"},
            { id: 7, text:"July"},
            { id: 8, text:"August"},
            { id: 9, text:"September"},
            { id: 10, text:"October"},
            { id: 11, text:"November"},
            { id: 12, text:"December"},
          ],

          json_fields: {
            PRODUCT_NAME: "product",
            TOTAL_SALES: "totalsales",
            PER_MONTH: "permonth",
            PER_DAY: "perday",
          },
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],
        };
      },
      computed: {
             // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
          ]),
          ...mapGetters("saledetails", ["filterStatus","Consumption"]),
        ...mapGetters("setting", ["GeneralSettings"]),
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.Consumption ? this.Consumption.length : 1;
        },
    
        /**
         * Todo list of records
         */
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.Consumption ? this.Consumption.length : 1;
      },  
      methods: {
        ...mapActions({
            FetchConsumptionSummary: "saledetails/fetchProductionConsumption",
            FetchGeneralSettings: "setting/fetchGeneralSettings",
        }),
    
        // COMMA SEPERATORS
        thousandSeperator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
                .toString()
                .replace(/[^0-9.]+/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
    
        SalesAnalysisData() {
        this.FetchConsumptionSummary(this.filterSales);

        },
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
      },
      updated() {
        let total_amount = 0;
          // let total_paid = 0;
          if(this.Consumption){
            this.Consumption.forEach((item)=>{
              total_amount = total_amount+parseInt(item.amount);
            });
            this.total_amount = total_amount;
          }                 
      },
      watch: {
        SalesAnalysis(newValue){
          if(newValue == true){
            this.SalesAnalysisData();
          }
        }
      },
      created() {
       this.FetchConsumptionSummary(this.filterSales);
       this.FetchGeneralSettings();
      },
    };
    </script>
    
    <template>
      <Layout>
        <div class="row py-3 text-center">
          <!-- <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4> -->
        </div>
        <PageHeader :title="title" :items="items" />
    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-9">
                    <h3 class="card-title mb-2 text-center">Product Average Consumption</h3>
                  </div>
                </div>  
                 
                <div class="row">                                  
                  <div class="col-md-3 mt-4">
                    <download-excel
                      class="btn btn-info"
                      :data="Consumption"
                      :fields="json_fields"
                      :worksheet="'PRODUCT AVERAGE CONSUMPTION'"
                      type="csv"
                      :name="'ProductAverageConsumption for Month ('+filterSales.month+') Year ' + filterSales.year + '.xls'"
                    >
                      Export Excel <i class="fa fa-download"></i>
                    </download-excel>
                  </div>
                  <div class="col-md-3 form-group">
                    <label>MONTH</label>
                    
                    <model-list-select
                      :list="Months ? Months : []"
                      v-model="filterSales.month"
                      option-value="id"
                      option-text="text"
                      placeholder="Select Month"
                      @input="SalesAnalysisData()"
                    >
                    </model-list-select>
                  </div>
                  <div class="col-md-3 form-group">
                    <label>YEAR</label>
                    
                    <input
                      v-model="filterSales.year"
                      placeholder="Enter Year"
                      class="form-control"
                      @keyup.enter="SalesAnalysisData()"
                    />
                  </div>
                  <div class="col-md-3 mt-4">
                  <button class="btn btn-primary" type="button" @click="SalesAnalysisData()">
                    <span class="fa fa-filter"></span> Filter
                    <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                    ></b-spinner>
                  </button>
                </div>
                </div>            
                <div class="row mt-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                    <b-table
                  class="datatables"
                  :items="Consumption?Consumption:[]"
                  :fields="monthfields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>            
              </b-table>                   
                  
                <!-- <div> -->
            </div>
                <Loader  v-if="!Consumption"/>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </template>
    
    <style>
    .btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    </style>
    